import styled from 'styled-components'

import Dropdown from 'components/Dropdown'
import { DropdownButton } from 'modules/shares/components/DocumentItem'

import { ReactComponent as BaseEllipsisIcon } from 'icons/ellipsis-20.svg'

export const EllipsisIcon = styled(BaseEllipsisIcon)`
  width: 20px;
  height: 20px;
`

export const TableButton = styled(DropdownButton).attrs({})`
  color: ${({ theme: { colors } }) => colors.foreground.secondary[4]};

  &:hover {
    color: inherit;
  }
`

export const DropdownHeader = styled(Dropdown.Header)`
  padding-top: 8px;
`

export const DropdownItemDescription = styled(Dropdown.ItemDescription)`
  font-size: 0.6875rem;
  color: ${({ theme }) => theme.colors.text.dark.secondary};
`
